import { Colors } from '../../../shared/theme/';

export default {
  defaultContent: {

  } as React.CSSProperties,
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    paddingBottom: '16px',
    height: '56px'
  } as React.CSSProperties,
  headerText: {

  } as React.CSSProperties,
  icon: {
    color: Colors.lightPurple,
    fontSize: '18px',
    cursor: 'pointer'
  } as React.CSSProperties,
  editWrapper: {
    backgroundColor: Colors.white,
    padding: 40,
  } as React.CSSProperties,
  tableWrapper: {
    backgroundColor: Colors.white,
    padding: 20,
  } as React.CSSProperties,
  menu: {
    fontFamily: 'Kanit-Regular'
  },
  selectedMenuItem: {
    backgroundColor: '#FCF4FA'
  },
  emptyWrapper: {
    textAlign: 'center'
  } as React.CSSProperties
};
